import { NonAbapQueryDetailsFragment } from 'generated/graphql';
import { UpdateNonAbapQueryState } from 'stores/interfaces/UpdateQueryState';
import { SetState } from 'zustand';

export const createUpdateNonAbapQuerySlice = (set: SetState<UpdateNonAbapQueryState>) => ({
  setInitialStateWithProps: (queryDetails: NonAbapQueryDetailsFragment) =>
    set({
      xtmProjectName: queryDetails.xtmProjectName,
      repository: queryDetails.repository,
      collection: queryDetails.collection,
      fileName: queryDetails.fileName,
      stringId: queryDetails.stringId,
      sourceContact: queryDetails.sourceContact
    })
});
